import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { Box, Button, Grid, Skeleton } from "@mui/material";
import React, { useState } from "react";
import CardHintCmp from "../../components/cardHint/cardHintCmp";
import DropzonePluseCmp from "../../components/dropzone/DropzonePluseCmp";
import ExcelFileViewer from "../../components/thumbnail/excelFileViewer";
import { useMutation } from "react-query";
import {
  ProcessDelayedInstallments,
  ProcessPayingInstallmentFile,
  GetInvalidInstallmentItems,
} from "../../services/loan.service";
import { ProcessPayingInstallmentFileResponse } from "../../models/loan.model";
import { toast } from "react-toastify";
export default function InstallmentRegistration() {
  const [attachmentDocument, setAttachmentDocument] = useState<any>();
  const [data, setData] = useState<ProcessPayingInstallmentFileResponse>();
  function handleOnFileChoosed(files: any) {
    if (!files || files.length === 0) return;
    const fileUrlObj: any = {
      file: files[0],
      fileUrl: files[0].preview,
      fileName: files[0].name,
    };
    setAttachmentDocument(fileUrlObj);
    ProcessPayingInstallmentFileMutate(files[0]);
  }
  const { mutate: ProcessPayingInstallmentFileMutate, isLoading } = useMutation(
    ProcessPayingInstallmentFile,
    {
      onSuccess: (data) => {
        setData(data);
      },
    }
  );
  const { mutate: ProcessDelayedInstallmentsMutate } = useMutation(
    ProcessDelayedInstallments,
    {
      onSuccess: (data) => {
        if (data.data) {
          toast.success("پردازش با موفقیت انجام شد.");
          setAttachmentDocument(undefined);
        }
      },
    }
  );
  const { mutate: GetInvalidInstallmentItemsMutate } = useMutation(
    GetInvalidInstallmentItems,
    {
      onSuccess: (data) => {},
    }
  );

  const test12 = [
    {
      walletName: "ghghh",
      walletAmount: 0,
    },
    {
      walletName: "ghg454545hh",
      walletAmount: 544554545,
    },
  ];
  return (
    <div>
      <CardHintCmp
        icon={<ReportProblemOutlinedIcon />}
        width="100%"
        title={
          <>
            برای ثبت وضعیت اقساط معوق، فایل اکسل "اقساط معوق" را دانلود نموده و
            پس از تکمیل ستون‌های "تاریخ پرداخت" و "مبلغ پرداخت شده" ، فایل را
            بارگذاری نمایید.
            <br />
            <br />
            &nbsp; &nbsp; &nbsp;&nbsp;امکان پردازش فایل پس از نمایش نتایج بررسی
            میسر خواهد شد.
          </>
        }
      />
      <Grid container xs={3}>
        {attachmentDocument ? (
          <div style={{ paddingBottom: "5vh " }}>
            <ExcelFileViewer
              file={attachmentDocument}
              onChange={setAttachmentDocument}
            />
          </div>
        ) : (
          <DropzonePluseCmp
            size={10}
            picName={"فایل اقساط معوق"}
            onFileChoosed={handleOnFileChoosed}
            errors={false}
          />
        )}
      </Grid>
      {attachmentDocument && (
        <Grid
          xs={7}
          container
          spacing={0}
          sx={{ border: "1px solid #DAE0E4", padding: "10px" }}
        >
          {isLoading ? (
            <Grid>
              {Array.from({ length: 3 }).map((_, index) => (
                <Grid item xs={12} key={index}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    borderRadius="2px"
                    p={1.5}
                  >
                    <Skeleton variant="text" width={200} height={25} />

                    <Skeleton variant="text" width={200} height={25} />
                  </Box>
                </Grid>
              ))}{" "}
            </Grid>
          ) : (
            <>
              {Object.entries(data?.information || {}).map(
                ([key, value], index) => (
                  <Grid item xs={12} key={index}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      borderRadius="2px"
                      p={1.5}
                    >
                      <Box flex={1} textAlign="right">
                        {key}:
                      </Box>

                      <Box flex={1} textAlign="left">
                        {value}
                      </Box>
                    </Box>
                  </Grid>
                )
              )}
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    className={`${
                      !data?.processable ? "disabledBtn btnForm " : "btnForm"
                    }`}
                    disabled={!data?.processable}
                    onClick={() => {
                      ProcessDelayedInstallmentsMutate({
                        processId: data?.processId!,
                      });
                    }}
                  >
                    پردازش
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    className="ComingBack btnForm"
                    onClick={() => {
                      GetInvalidInstallmentItemsMutate({
                        processId: 28,
                      });
                    }}
                    disabled={!data?.doesAnyInvalidRecordExist}
                  >
                    دانلود فایل رکوردهای خطا دار
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      )}
    </div>
  );
}
